/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/

angular.module('bulbApp.bitRateModule', ['lodash'])

  .constant('BITRATE', {

    defaultOptions: {
      timeout: 1000,
      lowerBoundBitrate: 320000,
      highestBoundBitrate: 1920000,
    },

    /**
   * The test files we have up on s3. The size of the file (in bits) is expected to be equal to the bitrate.
   * As a side note, these represent the bitrate of both the audio and the video of the files added together.
   */
    downloadFile: {
      size: 300000,
      url: 'https://assets.bulbapp.com/connection/test_connection_300kb.txt',
    },

  })
  .run(['$rootScope', 'BITRATE', function ($rootScope, BITRATE) {
    $rootScope.BITRATE = BITRATE;
  }]);
